@if(engagementDetails(); as details) {
<div class="engagement-viewer-overview-part">
	<div class="pt-2">
		<h5>
			<span class="badge bg-secondary-subtle text-black px-3 py-2">
				Status : {{details.closedUTC ? 'Closed' : 'Open'}}
			</span>
		</h5>
	</div>

	<div class="pt-0">
		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Contacted Person:</th>
					<td>
						<span role="button" type="button" class="text-decoration-underline"
							(click)="openPersonDialog(details.person.id)">
							{{details.person.fullName}}
						</span>
						({{details.externalRoleName}})
					</td>
				</tr>
				<tr>
					<th [width]="200">Created Date:</th>
					<td>{{details.engagementDateUTC}}</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Total Interactions:</th>
					<td>{{details.contactInteractions.length}}</td>
				</tr>
				<tr>
					<th [width]="200">Last Interaction on:</th>
					<td>{{details.lastContactUTC}}</td>
				</tr>
				<tr>
					<th [width]="200">Last Interaction with:</th>
					<td>{{details.lastContactedByStaffName}} ({{details.staffRoleName}})</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Purpose:</th>
					<td>{{details.purposeDesc}}</td>
				</tr>
				<tr>
					<th [width]="200">Activity:</th>
					<td>{{details.activity}}</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Details:</th>
					<td>{{details.details}}</td>
				</tr>
			</tbody>
		</table>

		@if(details.donorPotentialDetails){
		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Donor Potential:</th>
					<td>{{details.donorPotentialDetails || 'N/A'}}</td>
				</tr>
			</tbody>
		</table>
		}

	</div>
</div>
}